import ScrollTrigger from '@terwanerik/scrolltrigger'

export function scroll() {
	const trigger = new ScrollTrigger({
		trigger: {
			once: false,

			offset: {
				viewport: {
					x: 0,
					y: 0.55
				}
			},

			toggle: {
				class: {
					in: 'hover',
					out: 'no-hover'
				}
			}
		}
	})

	const fade_in = new ScrollTrigger({
		trigger: {
			once: true,

			offset: {
				element: {
					x: 0,
					y: 0.4
				}
			},

			toggle: {
				class: {
					in: 'fade-in'
				}
			}
		}
	})

	const fade = new ScrollTrigger({
		trigger: {
			once: true,

			offset: {
				element: {
					x: 0,
					y: 0.4
				}
			},

			toggle: {
				class: {
					in: 'fade'
				}
			}
		}
	})

	trigger.add('[data-trigger]')
	trigger.add('[data-trigger-once]', { once: true })
	fade_in.add('[data-fade-in]')
	fade.add('[data-fade]')
}
